import React from 'react';

/**
 * Uniform action-button row for start-page widget CTAs.
 *
 * Gives every start-page action button an identical footprint across widgets
 * and personas:
 *  - Mobile: full width, stacked (`col-12 d-grid`).
 *  - Tablet/desktop: compact fixed width (~230px), right-aligned — does not
 *    scale with the viewport, so buttons stay tidy on wide screens.
 *
 * The child should be a Bootstrap button/link; inside the `d-grid` column it
 * stretches to fill the column, so all CTAs render at the same width/height.
 */
export function WidgetActionRow({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`row justify-content-end g-0 ${className}`.trim()}>
      <div className="col-12 col-sm-auto d-grid" style={{ minWidth: 230 }}>
        {children}
      </div>
    </div>
  );
}
